import { RatingRequestsListPage } from './rating-requests-list/rating-requests-list'
import { JobRatingPage } from './job-rating/job-rating'

export const RatingRequestsStack = {
  RatingRequestsListPage,
  JobRatingPage,
}
